const getDefaultState = () => {
	return {
		authed: null,
		initialLoading: true,
		loading: false,
		refreshing: false,
		authedLoaded: false,
		impersonator: null,
		justLoggedIn: true,
		sessionTimerInterval: null,
		sessionExpires: null,
		sessionExpiresSeconds: null,
	};
};

const state = getDefaultState();

const actions = {
	reset({commit}) {
		commit("RESET");
	},
	authed({commit, dispatch}) {
		commit("SET_LOADING", true);
		return new Promise((resolve, reject) => {
			http().get("authed").then(response => {
				commit("SET_AUTHED", response.data.data);
				commit("SET_AUTHED_LOADED");
				commit("SET_IMPERSONATOR", response.data.impersonator);
				// commit("SET_JUST_LOGGED_IN", true);
				if (response.data.data.activeCall) {
					dispatch("activeCall/setActiveCall", response.data.data.activeCall, {root: true});
				}
				// new LandbotClass().initLandbot(window.landbotId);
				// window.channelManager?.init();
				resolve(response.data);
			}).catch(error => {
				commit("SET_AUTHED", null);
				reject(error);
			}).finally(() => {
				commit("SET_LOADING", false);
				commit("SET_INITIAL_LOADING", false);
			});
		});
	},
	refresh({commit}) {
		commit("SET_REFRESHING", true);
		return new Promise((resolve, reject) => {
			http().get("session-expiration").then(() => {
				resolve();
			}).finally(() => {
				commit("SET_REFRESHING", false);
			});
		});
	},
	impersonate({commit, dispatch}, id) {
		// // window.location = window.location.protocol + "://" + window.location.host + "/impersonate/" + id;
		// window.location = "impersonate/" + id;
		return new Promise((resolve, reject) => {
			return http().post("impersonate/" + id, {
				"endImpersonationRedirect": window.location.href,
			}).then(response => {
				commit("RESET", null, {root: true});
				if (response.data.redirect) {
					window.app.$router.replace({path: response.data.redirect});
				}
				return dispatch("authed").then(() => {
					resolve();
				});
			}).catch((error) => {
				console.log(error);
				reject();
			});
		});
	},
	endImpersonation({commit, dispatch}) {
		return new Promise((resolve, reject) => {
			return http().post("impersonation/stop").then(response => {
				commit("RESET", null, {root: true});
				if (response.data.redirect) {
					window.app.$router.replace({path: response.data.redirect});
				}
				return dispatch("authed").then(() => {
					resolve();
				});
			}).catch((error) => {
				console.log(error);
				reject();
			});
		});
	},
	startSessionTimer({state, dispatch}, minutes = null) {
		if (!minutes) {
			return;
		}
		clearInterval(state.sessionTimerInterval);
		state.sessionExpires = Math.floor(Date.now() / 1000) + ((minutes * 60) - 10);
		state.sessionTimerInterval = setInterval((state) => {
			let now = Math.floor(Date.now() / 1000);
			state.sessionExpiresSeconds = state.sessionExpires - now;
			if (state.sessionExpiresSeconds > 0) {
				return;
			}
			dispatch("logout", false);
		}, 1000, state);
	},
	logout({commit}, intended = false) {
		http(true).post(window.endpoints.base + "/logout", {
			intended: intended ? window.location.href : null,
		})
			.then(response => {
				let url = new URL(response.data.redirect);
				window.location.href = response.data.redirect;
			})
			.catch((error) => {
				if (error?.response?.status !== 419) {
					throw error;
				}
			});
	},
	set({commit}, data) {
		return new Promise((resolve) => {
			commit("SET", data);
			resolve(data.data);
		});
	},
};

const getters = {
	isDoingInitialLoad: (state) => {
		return state.initialLoading;
	},
};

const mutations = {
	RESET(state) {
		clearInterval(state.sessionTimerInterval);
		Object.assign(state, getDefaultState());
	},
	SET_LOADING(state, loading) {
		state.loading = loading;
	},
	SET_INITIAL_LOADING(state, loading) {
		state.initialLoading = loading;
	},
	SET_REFRESHING(state, refreshing) {
		state.refreshing = refreshing;
	},
	SET_AUTHED(state, data) {
		state.authed = data;
	},
	SET_AUTHED_LOADED(state) {
		state.authedLoaded = true;
	},
	SET_IMPERSONATOR(state, data) {
		state.impersonator = data;
	},
	SET_JUST_LOGGED_IN(state, data) {
		state.justLoggedIn = data;
	},
	APP_MODE(state, mode) {
		state.authed.appMode = mode;
	},
	UPDATE_NOTIFICATION(state, payload) {
		state.authed.notifications[payload.id] = payload;
	},
	SET(state, {key, data}) {
		_.set(state, "authed." + key, data);
	},
};

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations,
};
